// React
import React from 'react'
import PropTypes from 'prop-types'
import uiConnect from 'shared/redux/interface'
import { connect as reduxConnect, Provider } from 'react-redux'
import { compose } from 'redux'

// Components
import ProductDetail from '../components/product_detail'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

class QuickviewInner extends React.Component {
  static displayName = 'QuickviewInner'

  static propTypes = {
    item: PropTypes.any,
    itemId: PropTypes.string,
    closeWrapper: PropTypes.func,
    close: PropTypes.func
  }

  render () {
    const { itemId, item, closeWrapper, close } = this.props

    return (
      <div className="booqable-component" style={{ display: 'none' }}>
        <div
          id="booqable-quickview-wrapper"
          className={item ? 'open' : 'closed'}
          key={`booqable-quickview-${item?.id}`}
          onClick={closeWrapper}
        >
          <div id="booqable-quickview-inner">
            <button className="bq-close" onClick={close}>
              <i className="bq-icon-cross fas fa-times" />
            </button>
            {itemId && <ProductDetail uiKey={itemId} itemId={itemId} />}
          </div>
        </div>
      </div>
    )
  }
}

const uiToProps = {
  state: {
    itemId: null
  }
}

const mapStateToProps = (state, props) => {
  const itemId = props.ui.itemId

  return {
    itemId,
    item: state.orm.items.getById(itemId)
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const close = () => props.updateUI({ itemId: null })

  return {
    closeWrapper: (e) => {
      if (e.target.id === 'booqable-quickview-wrapper') {
        return close()
      }
    },
    close
  }
}

const QuickviewInnerComposed = compose(
  uiConnect('Quickview', uiToProps),
  reduxConnect(mapStateToProps, mapDispatchToProps)
)(QuickviewInner)

export default class Quickview extends React.Component {
  static displayName = 'Quickview'

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <QuickviewInnerComposed uiKey="" />
        </Themed>
      </Provider>
    )
  }
}
